import React from 'react';
import noResults from '../../assets/illustrations/no-resuts.svg';

import './no-data.scss';


import { SecondaryButton } from '../ui-toolkit/buttons.js';

const NoDataComponent = ({
	title,
	message,
	link,
	buttonLabel,
}) => (
	<div className="no-data-found">
		<div className="container col col-xs-12">
			<div className="not-found">
				<div className="img-content">
					<img src={noResults} alt="" />
				</div>
				<h3>
					{title}
				</h3>
				<p>
					{message}
				</p>
				{link ? (
					<SecondaryButton className="btn-small" to={link}>
						{buttonLabel}
					</SecondaryButton>
				) : ''}
			</div>
		</div>
	</div>
);

export default NoDataComponent;
